export default "__VITE_ASSET__Og1ihSIr__"